module.exports = __webpack_public_path__ + "img/key_west1.46b3ac03.jpg";